//------------------------------------------------//
//                                                //
//  Logic: Scroll logic.                          //
//                                                //
//------------------------------------------------//

export function scroll($) {

	//------------------------------------------------------
	// Scroll Status
	//------------------------------------------------------

	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var minScroll = 50;

	function hasScrolled() {

		var st = $(window).scrollTop();

		// Make sure they scroll more than delta

		if(Math.abs(lastScrollTop - st) <= delta) {
			return;
		}

		if (st > lastScrollTop) {
			// Scroll Down
			$('body').removeClass('scrolled--up scrolled--totop').addClass('scrolled--down');
			let topbarHeight = $('.site-header__topbar').outerHeight();
			$('.site-header').css('transform', 'translate(0, -'+topbarHeight+'px)');

		} else {
			// Scroll Up
			$('body').removeClass('scrolled--down scrolled--totop').addClass('scrolled--up');
			$('.site-header').css('transform', 'translate(0, 0)');

		}
		if (st < minScroll) {
			$('body').removeClass('scrolled--up scrolled--down').addClass('scrolled--totop');
			$('.site-header').css('transform', 'translate(0, 0)');
			
		}

		lastScrollTop = st;

	}

	// On resize for scrolled--tobottom // TODO Check or remove

	/*
	var st = $(window).scrollTop();
	if (st+window.windowHeight >= window.documentHeight-80) {
		$('body').removeClass('scrolled--up scrolled--down').addClass('scrolled--tobottom');
	} else {
		$('body').removeClass('scrolled--tobottom');
	}
	$(window).resize(function() {
		var st = $(window).scrollTop();
		if (st+window.windowHeight >= window.documentHeight-80) {
			$('body').removeClass('scrolled--up scrolled--down').addClass('scrolled--tobottom');
		} else {
			$('body').removeClass('scrolled--tobottom');
		}
	});*/


	//----------------------------------------------------
	// ON SCROLL
	//----------------------------------------------------

	hasScrolled();

	$(window).scroll(function(){
		didScroll = true;
	});

	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 250);


	// SOCIAL LIST
	if ($('.wrapper-social-wysiwyg').length && $('article.post').length){

		const listElm = $('.social');
		const elmDis = $('.module-post').find('.wysiwyg');
		const marginSocial = 20;
		const excerpt = 5;
		let heightHeader = $('.site-header__inner').outerHeight();
		let postTopHeight = $('.post').outerHeight();
		let postToTop = $('.post').offset().top;
		let socialTopHeight = $('.social-list').outerHeight();
		let scrollToTop = $(window).scrollTop();

		function socialPosition(eTop) {
			let elmDisHeight = $(elmDis).outerHeight();
			let eHeight = $('.social').height();
			let heightHeader = $('.site-header__inner').outerHeight();
			let elmTopHeight = $('.wrapper-social-wysiwyg').outerHeight();
			let elmToLeft = $('.wrapper-social-wysiwyg').offset().left;
			let eNelmDisHeight = (-elmDisHeight + (eHeight + heightHeader));
			let f = scrollToTop - (elmTopHeight - socialTopHeight);
			socialTopHeight = $('.social-list').outerHeight();
			scrollToTop = $(window).scrollTop();

			if ((eTop - $(window).scrollTop()) < heightHeader + marginSocial) {
				listElm.addClass('position-fixed')
									.removeClass('go-up')
										.css({ left: elmToLeft, top: heightHeader + marginSocial });
			} else if ((eTop - $(window).scrollTop()) > heightHeader) {
				listElm.removeClass('position-fixed')
								.removeClass('go-up')
									.css({ left: 0, top: 0 });
			}
			if (((eTop - marginSocial) - $(window).scrollTop()) < eNelmDisHeight) {
				listElm.removeClass('position-fixed')
									.addClass('go-up')
										.css({ left: 0, top: scrollToTop - f });
			}
		}

		$(function () {
			let eTop = listElm.offset().top;

			$(window).scroll(function () {
				let scrollToTop = $(window).scrollTop();
				heightHeader = $('.site-header__inner').outerHeight();

				if ($(window).width() > 630 && (scrollToTop + ((socialTopHeight + heightHeader - excerpt) )< (postTopHeight + postToTop  ))) {

					listElm.css({ left: 0, top: 0 });
					socialPosition(eTop);
				} else {
					listElm.removeClass('position-fixed');
				}
			});

			$(window).resize(function () {
				listElm.removeClass('position-fixed')
									.removeClass('go-up')
										.css({ left: 0, top: 0 });
				eTop = listElm.offset().top;
				heightHeader = $('.site-header__inner').outerHeight();
				postTopHeight = $('.post').outerHeight();
				postToTop = $('.post').offset().top;
				socialTopHeight = $('.social-list').outerHeight();
				scrollToTop = $(window).scrollTop();

				if ($(window).width() > 630 && (scrollToTop + ((socialTopHeight + heightHeader - excerpt)) < (postTopHeight + postToTop))) {
					socialPosition(eTop);

				} else {
					listElm.removeClass('go-up')
									.removeClass('position-fixed')
										.css({ left: 0, top: 0 });
				}
			});
		});
	}


}
